<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
          <span class="text">{{$t('readList.type')}}:</span>
          <el-radio-group size="medium" v-model="filter.type">
               <el-radio label>{{$t('readList.all')}}</el-radio>
              <el-radio :label="0">{{type(0)}}</el-radio>
              <el-radio :label="1">{{type(1)}}</el-radio>
          </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
          <span class="text">{{$t('readList.status')}}:</span>
          <el-radio-group size="medium" v-model="filter.status">
              <el-radio label>{{$t('readList.all')}}</el-radio>
              <el-radio :label="0">{{$t('readList.status0')}}</el-radio>
              <el-radio :label="1">{{$t('readList.status1')}}</el-radio>
              <el-radio :label="2">{{$t('readList.status2')}}</el-radio>
              <el-radio :label="3">{{$t('readList.status3')}}</el-radio>
              <el-radio :label="4">{{$t('readList.status4')}}</el-radio>
              <el-radio :label="5">{{$t('readList.status5')}}</el-radio>
          </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
            <span class="text">{{$t('readList.time')}}:</span>
            <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            :range-separator="$t('to')"
            :start-placeholder="$t('start_date')"
            :end-placeholder="$t('end_date')">
            </el-date-picker>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t("btnTip.add")
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
       <template v-slot:type="slotProps">
          <div>{{type(slotProps.callback.row.type)}}</div>
        </template>
       <template v-slot:title="slotProps">
          <el-tooltip class="item" effect="dark" :content="$t('readList.toReadUseList')" placement="top">
            <div>{{slotProps.callback.row.title}}</div>
          </el-tooltip>
        </template>
      <template v-slot:start_time="slotProps">
          <div>{{slotProps.callback.row.start_time}}~{{slotProps.callback.row.end_time}}</div>
        </template>
        <template v-slot:apply="slotProps">
          <div class="under_line" @click="handleClick('readUseList',slotProps.callback.row)">{{slotProps.callback.row.apply_num}}/{{slotProps.callback.row.total_num}}</div>
        </template>
        <template v-slot:cover="slotProps">
          <div>
              <img width="100%" :src="slotProps.callback.row.cover" alt />
          </div>
        </template>
        <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">
              {{status(slotProps.callback.row.status)}}
          </el-tag>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip class="item" effect="dark" :content="$t('btnTip').check" placement="top">
             <el-button
              @click="handleClick('check',slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
           <el-tooltip class="item" effect="dark" :content="$t('btnTip').edit" placement="top">
            <el-button
              @click="handleClick('edit',slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-dropdown class="ml10 mr10" @command="handleCommand">
            <el-button
                type="warning"
                size="mini"
              >{{$t('readList.more')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{type:'notice',id:slotProps.callback.row.id}">{{$t('readList.toNotice')}}</el-dropdown-item>
              <el-dropdown-item :command="{type:'task',id:slotProps.callback.row.id}">{{$t('readList.toTask')}}</el-dropdown-item>
              <el-dropdown-item :command="{type:'topic',id:slotProps.callback.row.id}">{{$t('readList.toTopic')}}</el-dropdown-item>
              <el-dropdown-item :command="{type:'comment',id:slotProps.callback.row.id}">{{$t('readList.toComment')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat'
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { readList, deleteRead } from "@/api/api";
export default {
  name: "readList",
  mixins: [mixin_list(readList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        type:"",
        status:"",
        start_time:"",
        end_time:"",
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("readList.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("readList.type"),
          sortable: true,
          prop: "type",
          slot:"type"
        },
        {
          label: this.$t("readList.title"),
          sortable: true,
          prop: "title",
          slot:"title"
        },
        {
          label: this.$t("readList.option"),
          sortable: true,
          prop: "option"
        },
        {
          label: this.$t("readList.price"),
          sortable: true,
          prop: "price"
        },
        {
          label: this.$t("readList.time"),
          sortable: true,
          prop: "start_time",
          slot:"start_time"
        },
        {
          label: this.$t("readList.apply"),
          sortable: true,
          prop: "apply_num",
          slot:"apply"
        },
        {
          label: this.$t("readList.cover"),
          sortable: true,
          slot:"cover"
        },
        {
          label: this.$t("readList.status"),
          sortable: true,
          prop: "status",
          slot:"status"
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 300,
          slot: "operation",
           fixed:"right"
        },
      ],
      dateValue:'',
    }
  },
  watch:{
      dateValue(){
          if(this.dateValue===null){
              this.filter.start_time=''
              this.filter.end_time=''
              return
          }
          this.filter.start_time=time.currentTime(this.dateValue[0])
          this.filter.end_time=time.currentTime(this.dateValue[1])
      }
  },
  methods: {
      statusTag(status){
      switch(status){
          case 0:
            return 'primary'
          case 1:
            return 'success'
          case 2:
            return 'info'
          case 3:
            return 'danger'
          case 4:
            return 'info'
          case 5:
            return 'info'
      }
    },
    status(status){
      switch(status){
          case 0:
            return this.$t('readList.status0')
          case 1:
            return this.$t('readList.status1')
          case 2:
            return this.$t('readList.status2')
          case 3:
            return this.$t('readList.status3')
          case 4:
            return this.$t('readList.status4')
          case 5:
            return this.$t('readList.status5')
      }
    },
    type(type){
        switch(type){
            case 0:
                return this.$t('readList.type0')
            case 1:
                return this.$t('readList.type1')
        }
    },
    handleCommand(command) {
        switch(command.type){
          case 'notice':
            this.$router.push(`/readManagement/readList/${command.id}/readNoticeList`)
            break
          case 'task':
            this.$router.push(`/readManagement/readList/${command.id}/readTaskList`)
            break
          case 'topic':
            this.$router.push(`/readManagement/readList/${command.id}/readTopicList`)
            break
          case 'comment':
            this.$router.push(`/readManagement/readList/${command.id}/readCommentList`)
            break
        }
    },
    async handleClick(type, data) {
      switch (type) {
        case "check":
          this.$router.push(`/readManagement/readList/detail?id=${data.id}`)
          break;
        case "add":
          this.$router.push('/readManagement/readList/edit')
          break;
        case "edit":
          this.$router.push(`/readManagement/readList/edit?id=${data.id}`)
          break;
        case "readUseList":
          this.$router.push(`/readManagement/read_userList?id=${data.id}`)
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('readList').sureDeleteRead, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteRead(id)
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.text{
  width:100px;
  font-size: 16px;
}
/deep/ label{
  margin-bottom:0!important
}
</style>